module.exports = __webpack_public_path__ + "img/main8.a89d3f6f.png";